// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3rg3J","emails":"CreateEditClinics_emails__qXNJc","emailTagLabel":"CreateEditClinics_emailTagLabel__fJ8yV"};